"use client"

import { useLayoutEffect } from "react"
import { useGetUserAttributesQuery } from "lib/services/userDataService"
import { setLoggedInUser } from "utils/analytics"

/**
 * Use this only inside an app and at most once. Currently used to set the
 * currently active app name so that it can be sent with all events to GTM
 */
function AnalyticsBase({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetUserAttributesQuery({})

  // Using `useLayoutEffect` so that we can set app as early as possible.
  useLayoutEffect(() => {
    if (data) {
      setLoggedInUser(data)
    }
  }, [data])

  if (!isLoading) return children
}

export default AnalyticsBase
